// Shell for every signed-in route: auth guard, club state, and the header.
//
// Rendered as a react-router layout route so the ClubProvider stays mounted
// across navigation — /v1/me is fetched once per session instead of once per
// page, and switching clubs doesn't re-fetch it at all.

import { Outlet } from "react-router-dom";
import { ClubProvider } from "../ClubContext";
import { Header } from "./Header";
import { RequireAuth } from "./RequireAuth";

export function AuthedLayout() {
  return (
    <RequireAuth>
      <ClubProvider>
        <div className="min-h-screen">
          <Header />
          <Outlet />
        </div>
      </ClubProvider>
    </RequireAuth>
  );
}
